/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { UserContactValidateDto } from '../../models/user-contact-validate-dto';
import { UserEmailDto } from '../../models/user-email-dto';

export interface UserClientControllerFindEmailV1$Params {
      body: UserContactValidateDto
}

export function userClientControllerFindEmailV1(http: HttpClient, rootUrl: string, params: UserClientControllerFindEmailV1$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<UserEmailDto>>> {
  const rb = new RequestBuilder(rootUrl, userClientControllerFindEmailV1.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<UserEmailDto>>;
    })
  );
}

userClientControllerFindEmailV1.PATH = '/api/v1/users/client/find/email';
